<template>
  <div style="width: 100%;height: 100%;overflow: hidden !important;position: absolute;">
    <div style="width: 100%;height: 100vh;overflow-y: scroll;padding-bottom: 100px;">
      <RecordList v-if="formStatus == 'list'" :page="page" :buttonPriviledgeList="buttonPriviledgeList"
            @addCallbackDetail="handleDetail" @addCallbackDetailList="handleDetailList"
            @addCallbackCreate="handleCreate" @addCallbackPrint="handlePrint" @addCallbackPrintList="handlePrintList"></RecordList>
      <RecordDetail v-if="formStatus == 'detail'" :item="item" :page="page" :buttonPriviledgeList="buttonPriviledgeList" @back="back"></RecordDetail>
      <RecordDetailList v-if="formStatus == 'detailList'" :item="item" :buttonPriviledgeList="buttonPriviledgeList" :page="page" @back="back"></RecordDetailList>
      <AddRecord v-if="formStatus == 'add'" :item="item" :page="page" @back="back"></AddRecord>
      <RecordPrint v-if="formStatus == 'print'" :item="item" :page="page" @back="back"></RecordPrint>
      <RecordPrintList v-if="formStatus == 'printList'" :item="item" :page="page" @back="back"></RecordPrintList>
    </div>
  </div>
</template>

<script>
import RecordList from "@/views/sm/market/groupon/grouponList";
import AddRecord from "@/views/sm/market/groupon/grouponCreate";
import RecordDetail from "@/views/sm/market/groupon/grouponDetail";
import RecordDetailList from "@/views/sm/market/groupon/grouponDetailList";
import RecordPrint from "@/views/sm/market/groupon/groupPrintItem";
import RecordPrintList from "@/views/sm/market/groupon/groupPrintList";
import {default as PermissionApi} from "@/api/smp/auth/Permission";
export default {
  name: "groupInfo",
  components: {RecordList, AddRecord, RecordDetail, RecordDetailList, RecordPrint, RecordPrintList},
  props: {
    page: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      formStatus: 'list',
      item: null,
      buttonPriviledgeList: []
    }
  },
  created() {
    this.getButtonPriviledge()
  },
  mounted() {

  },
  methods: {
    handleDetail(data){
      console.log(data)
      this.formStatus = 'detail';
      this.item = data.item;
    },
    handleDetailList(data) {
      this.formStatus = 'detailList';
      this.item = data.item;
    },
    handlePrint(data) {
      this.formStatus = 'print';
      this.item = data.item;
    },
    handlePrintList(data) {
      this.formStatus = 'printList';
      this.item = data.item;
    },
    handleCreate(data){
      console.log(data)
      this.formStatus = 'add';
      this.item = data.item;
    },
    back(){
      this.formStatus='list';
    },
    getButtonPriviledge(){
      console.log('this.page',this.page)
      let menuId = this.page.id
      let me = this
      PermissionApi.queryButtonPriviledge(menuId,null).then(resp=>{
        PermissionApi.handleResponse(resp, me, function (data){
          me.buttonPriviledgeList = data.buttonPriviledges
          console.log('buttonPriviledgeList',me.buttonPriviledgeList)
        })
      })
    },
    _hasButtonPermission(name) {
      let buttonPriviledgeList = this.buttonPriviledgeList
      let hasButton = false
      for (let i = 0; i < buttonPriviledgeList.length; i++) {
        if (buttonPriviledgeList[i].name == name) {
          if (buttonPriviledgeList[i].hasPriviledge == 'Y') {
            return true
          } else {
            return false
          }
        }
      }
      return false
    }
  }
}
</script>

<style scoped>

</style>